// extracted by mini-css-extract-plugin
export default {"fallback":"styles_fallback__nwspO","error-message":"styles_error-message__zh3oW"};